import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button from '../../../../../../Button';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { getDeviationResourceType, getDeviationType, } from '../../../../../_helpers';
import { DeviationTypes } from '../../../../../../types/deviation';
import thumbPaywallStyles from './ThumbPaywall.scss';
var unlockHint = function (type) {
    if (type === DeviationTypes.FILM) {
        return 'deviationview.overlay.privilegedFolder.unlockHint.pay.video';
    }
    return 'deviationview.overlay.privilegedFolder.unlockHint.pay';
};
var PrivilegedThumbPaywall = function (_a) {
    var deviation = _a.deviation, isSmall = _a.isSmall, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(thumbPaywallStyles['root'], isSmall && thumbPaywallStyles['small'], className) },
        React.createElement("div", { className: thumbPaywallStyles['label'] }, t(unlockHint(getDeviationType(deviation)))),
        React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
            React.createElement(Button, { view: "b18", height: "medium", className: thumbPaywallStyles['button'], biData: BiData({
                    evid: 375,
                    referral_info: ReferralType.CORE_LOUNGE,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                }), href: URLS.CORE_MEMBERSHIP }, t('deviationview.overlay.privilegedFolder.button.pay')))));
};
PrivilegedThumbPaywall.displayName = 'PrivilegedThumbPaywall';
export default PrivilegedThumbPaywall;
//# sourceMappingURL=PrivilegedThumbPaywall.js.map